export default __webpack_public_path__ + "static/2021-11-07-image1-84bf3710c560979455bafe3da2008393.svg";